import * as colorsExport from "./colors"
import * as fontsExport from "./fonts"

export const colors = colorsExport
export const fonts = fontsExport
